<template>
  <div class="cookie-banner">
    <div class="cookie-banner__header">
      <div class="cookie-banner__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" :fill="themeColor"/>
        </svg>
      </div>
      <span class="cookie-banner__title">{{ isUpdate ? $t('Cookies更新') : $t('Cookies') }}</span>
    </div>
    <div class="cookie-banner__body">
      <span class="cookie-banner__desc">
        {{ isUpdate ? $t('Cookie使用规则已更新,用于登录状态留存、体验优化与数据统计,详情见') : $t('本站通过Cookie留存登录信息、提升使用体验及统计服务数据，具体使用规则可查阅') }}
        <span class="cookie-banner__link" @click="goToPrivacyPolicy">{{ $t('Cookie协议政策') }}</span>。
      </span>
    </div>
    <div class="cookie-banner__bottom">
      <div class="cookie-banner__link-setting" @click="goToCookieDetail">
        {{ $t('Cookie 设置') }}
      </div>
      <div class="cookie-banner__actions">
        <div class="cookie-banner__btn cookie-banner__btn--outline" @click="onAccept('necessary')">
          {{ $t('仅接受必要') }}
        </div>
        <div class="cookie-banner__btn cookie-banner__btn--fill" @click="onAccept('all')">
          {{ $t('接受全部') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useThemeColor } from '@/utils/theme'

const props = defineProps<{
  isUpdate: boolean
  presentationUrl: string
}>()

const emit = defineEmits<{
  (e: 'accept', type: 'necessary' | 'all'): void
}>()

const router = useRouter()
const themeColor = useThemeColor()

function onAccept(type: 'necessary' | 'all') {
  emit('accept', type)
}

function goToCookieDetail() {
  router.push('/cookieSettings')
}

function goToPrivacyPolicy() {
  if (props.presentationUrl) {
    window.location.href = props.presentationUrl
  } else {
    router.push({ path: 'PrivacyPolicy' })
  }
}
</script>

<style lang="less" scoped>
.cookie-banner {
  background: #f0f1f1;
  padding: 16px;
  position: relative;
  z-index: 1001;
}

.cookie-banner__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.cookie-banner__icon {
  width: 28px;
  height: 28px;
  background: #FFF3E0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cookie-banner__title {
  font-size: 16px;
  font-weight: 600;
  color: #171921;
}

.cookie-banner__body {
  margin-bottom: 12px;
}

.cookie-banner__desc {
  font-size: 13px;
  color: #666;
  line-height: 20px;
}

.cookie-banner__link {
  color: v-bind(themeColor);
  cursor: pointer;
}

.cookie-banner__bottom {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cookie-banner__actions {
  display: flex;
  gap: 8px;
  flex: 1;
  justify-content: flex-end;
}

.cookie-banner__btn {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: none;

  &--outline {
    background: transparent;
    border: 1.5px solid v-bind(themeColor);
    color: v-bind(themeColor);
  }

  &--fill {
    background: v-bind(themeColor);
    color: #fff;
  }
}

.cookie-banner__link-setting {
  font-size: 12px;
  color: v-bind(themeColor);
  text-decoration: underline;
  cursor: pointer;
  flex-shrink: 0;
}
</style>
